import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { GridBox, MainLegendContainer } from "app/components/React/Legends/styledComponents";
import type { ILegendProps } from "app/components/React/Legends/legendsTypes";
import type React from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import styled from "styled-components";
import { CHART_COLORS } from "../../../constants/ChartColors";
import { Legends } from "./Legends";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

const AutoCompareWrapper = styled.div`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding-left: 18px;
    border: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 6px;
    height: 68px;
`;

const Competitors = styled.div`
    padding: 8px 0;
`;

const VS = styled.div`
    background-color: ${colorsPalettes.carbon[0]};
    height: 12px;
    font-size: 11px;
    margin: 6px 3px 6px 6px;
`;

const Circle = styled.div`
    width: 24px;
    height: 24px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    left: -12px;
    top: 21px;
    line-height: normal;
    text-align: right;
    text-transform: uppercase;
    border: 1px solid ${colorsPalettes.carbon[100]};
    background: ${colorsPalettes.carbon[0]};
`;

const CompareButtonWrapper = styled.div`
    margin: auto;
    margin-right: 19px;
`;

interface IAutoCompareLegendsProps extends ILegendProps {
    shouldUseStandardLegendCompare?: boolean; //todo Change naming
    onClearAllClick?: () => void;
}

export const AutoCompareLegends: React.FunctionComponent<IAutoCompareLegendsProps> = ({
    legendItems,
    toggleSeries,
    shouldUseStandardLegendCompare = false,
    onClearAllClick,
}) => {
    const colors = CHART_COLORS.compareMainColors;
    const mainSite = [];
    // extract the main site from the list
    mainSite.push(legendItems[0]);

    // extract the competitors from the list
    const competitors = legendItems.slice(1);
    competitors.map((item, index) => (item.color = colors[index + (1 % colors.length)]));

    const competitorsToCompare = competitors.filter((item) => item.visible ?? (item.hidden != null && !item.hidden));
    const compareList = competitorsToCompare.length ? [mainSite[0], ...competitorsToCompare] : legendItems;

    const onCompareAllClick = () => {
        allTrackers.dispatchTrackEvent("Pop Up", "click", "worldwideOverview/visitsOverTime/compareButton");
        proNavigator.updateParams({ key: compareList.map((item) => item.name).join(",") });
    };

    const buttonText = shouldUseStandardLegendCompare
        ? translate("analysis.header.auto.compare.btn", {
              count: compareList.length,
          })
        : translate("component.legends.checkboxVsCompare.button.clearAll");

    return (
        <GridBox>
            <MainLegendContainer>
                <Legends
                    legendItems={mainSite}
                    toggleSeries={toggleSeries}
                />
            </MainLegendContainer>
            <AutoCompareWrapper>
                <Circle>
                    <VS>VS.</VS>
                </Circle>
                <Competitors>
                    <Legends
                        legendItems={competitors}
                        toggleSeries={toggleSeries}
                    />
                </Competitors>
                <CompareButtonWrapper>
                    <Button
                        onClick={shouldUseStandardLegendCompare ? onCompareAllClick : onClearAllClick}
                        type={"outlined"}
                    >
                        {buttonText}
                    </Button>
                </CompareButtonWrapper>
            </AutoCompareWrapper>
        </GridBox>
    );
};
